var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "stretch": ""
    }
  }, [_c('v-row', {
    attrs: {
      "justify-content": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "8"
    }
  }, [_c('v-tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "selected": _vm.selected
    },
    on: {
      "click": function($event) {
        _vm.selected = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-separator'), _vm._v(" "), (_vm.selected === 'inn') ? _c('inn-form', {
    attrs: {
      "isIndividual": _vm.isIndividual,
      "on-create": _vm.onCreate,
      "total": _vm.total
    }
  }) : _c('search-form', {
    attrs: {
      "is-searching": _vm.isSearching,
      "is-individual": _vm.isIndividual,
      "total": _vm.total,
      "on-create": _vm.onCreate
    },
    on: {
      "search": function($event) {
        _vm.$emit('search', $event)
      }
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0feb0518","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/requestEgr/RequestEgr.vue
// module id = 1114
// module chunks = 0